'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { cn } from '../../../shared/cn';
import { P3 } from '../../typography/Paragraph';
import { colors } from './badgeStyles';

// type LabelComponentType = typeof Label1 | typeof Label2 | typeof Label3

export type BadgeProps = Omit<React.ComponentPropsWithoutRef<'span'>, 'size'> & {
  color?: keyof typeof colors;
  // size?: 1 | 2 | 3
};
export function Badge(t0) {
  const $ = _c(10);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      color: t1,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const color = t1 === undefined ? "default" : t1;
  const t2 = color && colors[color];
  let t3;
  if ($[4] !== className || $[5] !== t2) {
    t3 = cn("inline-flex h-fit items-center justify-center gap-x-1 text-nowrap rounded-full px-1.5 py-1 leading-4.5", t2, className);
    $[4] = className;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== props || $[8] !== t3) {
    t4 = <P3 {...props} className={t3} />;
    $[7] = props;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
export { colors } from './badgeStyles';